"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedTableField = exports.OrderColumnCell = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const table_field_1 = require("../table-field/table-field");
const form_field_context_1 = require("../../composite/form/fields/form-field-context");
const table_field_cells_1 = require("../table-field/table-field-cells");
function OrderColumnCell(props) {
    return react_1.default.createElement(table_field_cells_1.TableFieldCells.TextCell, Object.assign({}, props, { value: `${props.index}` }));
}
exports.OrderColumnCell = OrderColumnCell;
function NestedTableField({ nestedPath, nestedColumns, columns: directColumns, NestedFormFieldsComponent, FormFieldsComponent: DirectFormFieldsComponent, ...props }) {
    const columns = react_1.useMemo(() => lodash_1.compact([
        ...directColumns,
        ...nestedColumns.map((column) => ({
            ...column,
            datakey: `${nestedPath}.${column.datakey}`,
        })),
    ]), [directColumns, nestedColumns, nestedPath]);
    const FormFieldsComponent = react_1.useMemo(() => function FormFieldsComponent(props) {
        var _a, _b;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            DirectFormFieldsComponent && (react_1.default.createElement(DirectFormFieldsComponent, Object.assign({}, props))),
            react_1.default.createElement(form_field_context_1.FormFieldContext.Provider, { value: { prefix: nestedPath } }, NestedFormFieldsComponent && (react_1.default.createElement(NestedFormFieldsComponent, { initialValue: (_b = (_a = props.initialValue) === null || _a === void 0 ? void 0 : _a[nestedPath]) !== null && _b !== void 0 ? _b : null })))));
    }, [DirectFormFieldsComponent, NestedFormFieldsComponent, nestedPath]);
    return (react_1.default.createElement(table_field_1.TableField, Object.assign({}, props, { columns: columns, FormFieldsComponent: FormFieldsComponent })));
}
exports.NestedTableField = NestedTableField;
//# sourceMappingURL=nested-table-field.js.map